var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommonAttribute = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 13 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.6,
  d: "M5.078 6.688a2.693 2.693 0 0 0 4.061.291l1.616-1.616a2.693 2.693 0 0 0-3.808-3.807l-.926.92m1.212 3.135a2.693 2.693 0 0 0-4.061-.29L1.556 6.935a2.693 2.693 0 0 0 3.808 3.808l.92-.921"
})));
export default SvgCommonAttribute;